export class PriceCalculator {
    constructor(priceFormatter, convertTHBToMMK) {
        this.priceFormatter = priceFormatter;
        this.convertTHBToMMK = convertTHBToMMK;

        this.minTotalShippingFeeTHB =
            parseFloat(process.env.REACT_APP_MIN_TOTAL_SHIPPING_FEE_THB) || 1;
        this.minTotalShippingFeeMMK =
            parseFloat(process.env.REACT_APP_MIN_TOTAL_SHIPPING_FEE_MMK) || 500;
    }

    calculateItemTotal(priceTHB, quantity) {
        const unitPriceMMK = this.convertTHBToMMK(priceTHB);
        return {
            THB: this.priceFormatter.round(priceTHB * quantity),
            MMK: this.priceFormatter.round(unitPriceMMK * quantity)
        };
    }

    calculateDiscountAmount(orgPriceTHB, discountedPriceTHB, quantity) {
        const orgTotal = this.calculateItemTotal(orgPriceTHB, quantity);
        const discountedTotal = this.calculateItemTotal(discountedPriceTHB, quantity);

        return {
            THB: this.priceFormatter.round(orgTotal.THB - discountedTotal.THB),
            MMK: this.priceFormatter.round(orgTotal.MMK - discountedTotal.MMK)
        };
    }

    accumulateTotals(accumulator, itemTotals) {
        return {
            THB: accumulator.THB + itemTotals.THB,
            MMK: accumulator.MMK + itemTotals.MMK
        };
    }

    convertToDualCurrency(valueTHB) {
        return {
            THB: this.priceFormatter.round(valueTHB),
            MMK: this.priceFormatter.round(this.convertTHBToMMK(valueTHB))
        };
    }

    applyMinTotalShippingFee(shippingFee) {
        return {
            THB: Math.max(shippingFee.THB, this.minTotalShippingFeeTHB),
            MMK: Math.max(shippingFee.MMK, this.minTotalShippingFeeMMK)
        };
    }

    calculateOriginalPrice(discountedPriceTHB, discountPercent) {
        if (discountPercent >= 100) {
            throw new Error("Discount percent must be less than 100.");
        }
        if (discountPercent < 0) {
            throw new Error("Discount percent cannot be negative.");
        }

        const originalPriceTHB = discountedPriceTHB / (1 - discountPercent / 100);

        return this.convertToDualCurrency(originalPriceTHB);
    }
}
